import { IAPINotification, INotification } from './interface/INotification'

export const transformNotifications = (
  apiData: IAPINotification[] | [],
): INotification[] =>
  apiData.map(data => ({
    id: data.id,
    establishmentId: data.establishment_id,
    type: data.type,
    subject: data.subject,
    body: data.body,
    action: data.action,
    icon: data.icon,
    isRead: data.is_read,
    createdAt: data.created_at,
  }))
